import React from "react";

function Proyecto(props) {
    return (
            <video style={{
                "height": "205px", 
                "width": "364px",
                "borderRadius": "10px",
                "margin": "5px 10px 5px 10px"
            }} controls loop muted>
                <source src={props.vURL} type="video/mp4"/>
            </video>
    );
}

export default Proyecto;